<template>
    <footer class="footer">
        <div class="container footerStyle">
        
    <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid ">
        <ul class="navbar-nav">
            <li class="nav-item">
                <a class="nav-link">321, North Clark Street, Chicago, IL 60654-7598, Phone: 800.285.2221</a>
            </li>
        </ul>
        <ul class="navbar-nav ms-auto">
            <li class="nav-item">
                    <a class="nav-link">Copyright © {{new Date().getFullYear()}} American Bar Association. All rights reserved.</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link">Powered by</a>
                </li>
                <li class="nav-item">
                    <img src="../assets/tf_logo.png" alt="ABA Logo" style="width:100px; padding-top: 13px;"> 
                </li>
        </ul>
    </div>
  </nav>
</div>
    </footer>
</template>

<style scoped>
.footer {
  /* position: fixed; */
  bottom: 0;
  width: 100%;
  font-size: 12px;
  height: 53px;
  font: 'Roboto';
  font-weight: 500;
  background-color: #D9EFFD;
  color: black;
  width: 100%;
  /* position: absolute; */
  bottom: 0;
}

.footerStyle{
    background-color: #D9EFFD;
    color: black;
    padding-left: 0;
    margin-left: 0;
    margin-right: 0;
    padding-right: 0;
}

</style>